import { render } from "./MemberSignUp.vue?vue&type=template&id=2a03e881&scoped=true"
import script from "./MemberSignUp.vue?vue&type=script&lang=js"
export * from "./MemberSignUp.vue?vue&type=script&lang=js"

import "./MemberSignUp.vue?vue&type=style&index=0&id=2a03e881&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a03e881"]])

export default __exports__